import React, { Component } from 'react';
import ConfiguratorSection from './../ConfiguratorSection';
import ConfiguratorImage from './../ConfiguratorImage';
import ConfiguratorOption from './../ConfiguratorOption';
import Disclaimer from '../Disclaimer';
import MaterialSelector from '../MaterialSelector';
import { withTranslation, Trans } from 'react-i18next';
import { interiorA02ImageOptions } from './views/InteriorA02'


class Heads extends Component {
    constructor(props) {
        super(props);
		this.handleVeneerChange = this.handleVeneerChange.bind(this);
		this.handleFittingsChange = this.handleFittingsChange.bind(this);
	}

	handleVeneerChange(newValue, bubble = true) {
		let configuration = this.props.configuration;
		configuration.Veneer = newValue;

		if (bubble) {

			let fittingId = newValue.value;

			if (newValue.value === 4) {

				fittingId = 2;
			}

			let fitting = this.props.FittingsOptions.find(x => x.value === fittingId);

			this.handleFittingsChange(fitting, false);

		}


		if (this.props.onChange) {
			this.props.onChange(configuration);
		}
	}

	handleFittingsChange(newValue, bubble = true) {
		let configuration = this.props.configuration;
		configuration.Fittings = newValue;

		if (bubble) {

			let veneerId = newValue.value;

			if (newValue.value === 2) {

				veneerId = 4;
			}

			let veneer = this.props.VeneerOptions.find(x => x.value === veneerId);

			this.handleVeneerChange(veneer, false);

		}

		if (this.props.onChange) {
			this.props.onChange(configuration);
		}
	}

    render() {
		let imageOptions = interiorA02ImageOptions;

        let image = (
                <ConfiguratorImage boat="Xpower" configuration={this.props.configuration} options={imageOptions} />
        );

        return (
            <ConfiguratorSection image={image}>

                <ConfiguratorOption style={{ position: 'relative' }}>

					<h1><Trans defaults='Heads' /></h1>
					<h2><Trans defaults='Veneer' /></h2>
					<MaterialSelector options={this.props.VeneerOptions} label={this.props.configuration.Veneer.label} value={this.props.configuration.Veneer} onChange={this.handleVeneerChange} />
					<h2><Trans defaults='Finish' /></h2>

					<MaterialSelector options={this.props.FittingsOptions} label={this.props.configuration.Fittings.label} value={this.props.configuration.Fittings} onChange={this.handleFittingsChange} />


                    <Disclaimer />


                </ConfiguratorOption>
            </ConfiguratorSection>
        );
    }
}

export default withTranslation()(Heads);


// WEBPACK FOOTER //
// ./src/Xpower/Heads.js